"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NEW_CLASS_REFERRER_KEY = exports.NewClassReferrer = void 0;
exports.NewClassReferrer = {
    MODULE_EDITOR: 'ButtonManageClasses',
    CLASS_LIST: 'ButtonNewClass'
};
exports.NEW_CLASS_REFERRER_KEY = 'ClubAdminNewClassReferrerKey';
class ClassReferrerUtil {
    setValue(value) {
        sessionStorage.setItem(exports.NEW_CLASS_REFERRER_KEY, value);
    }
    getValue() {
        const savedValue = sessionStorage.getItem(exports.NEW_CLASS_REFERRER_KEY) || '';
        const isValid = Object.values(exports.NewClassReferrer).includes(savedValue);
        return isValid && savedValue ? savedValue : exports.NewClassReferrer.CLASS_LIST;
    }
    clearValue() {
        this.setValue('');
    }
}
exports.default = new ClassReferrerUtil();
